export default __webpack_public_path__ + "static/media/movieapp.80a46f15.jpg";